import styled from 'styled-components'
import { colors, measurments } from '../utils/config'

const StyledCustomerInput = styled.div<{ $noMargin: boolean }>`
  label,
  span,
  input {
    display: block;
  }
  label {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    color: inherit;
    font-weight: 500;
  }
  span {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: inherit;
    opacity: 0.7;
    margin-bottom: 0.4rem;
  }
  input {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid ${colors.gray500};
    border-radius: ${measurments.borderRadius}px;
    font-size: 0.875rem;
    color: ${colors.gray700};
    padding: 0.6rem;
    &[type='color'] {
      padding: 0;
      border: none;
      background: none;
      border-radius: ${measurments.borderRadius}px;
      overflow: hidden;
    }
  }
  margin-bottom: ${({ $noMargin }) => ($noMargin ? '0' : '1.6rem')};
`

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  noMargin?: boolean
  desc?: string
  label: string
}

const CustomerInput = (props: Props) => {
  const { label, desc, noMargin, ...inputProps } = props
  return (
    <StyledCustomerInput $noMargin={!!noMargin}>
      {props.label && <label htmlFor={props.id}>{label}</label>}
      {desc && <span>{desc}</span>}
      <input {...inputProps} />
    </StyledCustomerInput>
  )
}

export default CustomerInput
